if (!customElements.get("td-lp-product-selector")) {
  class TdProductSelector extends HTMLElement {
    constructor() {
      super();     
      // Get all product items
      this.productItems = this.querySelectorAll('.td-lpcp__product-selector--item');
      // Get the form and button
      this.productForm = this.querySelector('.product-form form');
      this.atcButton = this.querySelector('.td-lpcp__atc-button');
      // Get price element
      this.priceElement = this.querySelector('[data-atc-price]');
      // Get toggle buttons
      this.toggleButtons = this.querySelectorAll('.td-lpcp__toggle-input');
      // Store the current active product and purchase type
      this.activeProduct = null;
      this.currentPurchaseType = 'subscription';
    }

    connectedCallback() {
      // Add click event listeners to all product items
      this.productItems.forEach(item => {
        item.addEventListener('click', () => this.handleProductClick(item));
      });

      // Add click listener to ATC button
      if (this.atcButton) {
        this.atcButton.addEventListener('click', (e) => this.handleATCClick(e));
      }

      // Add change listeners to toggle buttons
      this.toggleButtons.forEach(button => {
        button.addEventListener('change', (e) => this.handleToggleChange(e));
      });

      // Set up initial state
      const initialActiveProduct = this.querySelector('.td-lpcp__product-selector--item.td-active');
      if (initialActiveProduct) {
        this.handleProductClick(initialActiveProduct);
      } else {
        // If no active product is set, set the first one as active and handle free gift
        if (this.productItems.length > 0) {
          this.handleProductClick(this.productItems[0]);
        }
      }
    }


    handleProductClick(clickedItem) {
      // Remove td-active class from all items
      this.productItems.forEach(item => {
        item.classList.remove('td-active');
      });

      // Add td-active class to clicked item
      clickedItem.classList.add('td-active');

      // Store the active product
      this.activeProduct = clickedItem;

      // Update the form with the selected product's variant ID
      if (this.productForm) {
        const variantId = clickedItem.dataset.variantId;
        const variantInput = this.productForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }

      // Update prices
      this.updatePrices(clickedItem);
      
      // Update all card prices
      this.updateCardPrices();
      
      // Dispatch event for free gift component
      this.dispatchFreeGiftEvent();
    }

    dispatchFreeGiftEvent() {
      // Get the selected product ID and purchase type
      const selectedProductId = this.activeProduct ? this.activeProduct.dataset.productItemId : null;
      
      // Dispatch custom event for free gift component
      const freeGiftEvent = new CustomEvent('free-gift-update', {
        detail: {
          productId: selectedProductId,
          purchaseType: this.currentPurchaseType
        },
        bubbles: true
      });
      
      this.dispatchEvent(freeGiftEvent);
    }

    updatePrices(productItem) {
      // Get prices from data attributes
      const subscriptionPrice = productItem.dataset.subscriptionPrice;
      const regularPrice = productItem.dataset.regularPrice;

      // Update price display based on current purchase type
      if (this.priceElement) {
        if (this.currentPurchaseType === 'subscription' && subscriptionPrice) {
          this.priceElement.textContent = subscriptionPrice;
        } else if (this.currentPurchaseType === 'onetime' && regularPrice) {
          this.priceElement.textContent = regularPrice;
        }
      }
    }

    handleToggleChange(e) {
      this.currentPurchaseType = e.target.value;
      
      // Update prices when toggle changes
      if (this.activeProduct) {
        this.updatePrices(this.activeProduct);
      }
      
      // Update all card prices
      this.updateCardPrices();
      
      // Dispatch event for free gift component
      this.dispatchFreeGiftEvent();
    }

    updateCardPrices() {
      // Update prices in all product cards
      this.productItems.forEach(item => {
        const priceWrapper = item.querySelector('.td-lpcp-price');
        if (!priceWrapper) return;

        const elements = {
          oneTimeSection: priceWrapper.querySelector('.td-lpcp__one-time-price'),
          subscriptionSection: priceWrapper.querySelector('.td-lpcp__subscription-price'),
          regularUnitPrice: priceWrapper.querySelector('[data-lpcp-price-regularunit-price]'),
          subscriptionUnitPrice: priceWrapper.querySelector('[data-lpcp-price-subscription-unit-price]')
        };

        this.toggleElements(elements, this.currentPurchaseType === 'subscription', {
          oneTimeSection: 'flex',
          subscriptionSection: 'flex',
          regularUnitPrice: 'block',
          subscriptionUnitPrice: 'block'
        });
      });
      
      // Update savings badges and descriptions based on purchase type
      this.updateSavingsBadges();
    }

    updateSavingsBadges() {
      // Update subscription savings badges
      const subscriptionSavings = document.querySelectorAll('[data-subscription-savings]');
      this.toggleElementsList(subscriptionSavings, this.currentPurchaseType === 'subscription', 'block');

      // Update regular savings badges
      const regularSavings = document.querySelectorAll('[data-regular-savings]');
      this.toggleElementsList(regularSavings, this.currentPurchaseType !== 'subscription', 'block');
      
      // Update descriptions based on purchase type
      this.updateDescriptions();
    }

    updateDescriptions() {
      // Update descriptions in all product cards
      this.productItems.forEach(item => {
        const elements = {
          subscriptionDescription: item.querySelector('[data-subscription-description]'),
          regularDescription: item.querySelector('[data-regular-description]')
        };

        this.toggleElements(elements, this.currentPurchaseType === 'subscription', {
          subscriptionDescription: 'block',
          regularDescription: 'block'
        });
      });

      // Update additional subscription text
      const additionalSubscriptionText = this.querySelector('.td-lpcp__product-selector--additional-subscription-text');
      if (additionalSubscriptionText) {
        additionalSubscriptionText.style.display = this.currentPurchaseType === 'subscription' ? 'block' : 'none';
      }
    }

    // Helper method to toggle elements based on condition
    toggleElements(elements, showSubscription, displayValues) {
      Object.keys(elements).forEach(key => {
        const element = elements[key];
        if (!element) return;

        const isSubscriptionElement = key.includes('subscription') || key.includes('Subscription');
        const shouldShow = showSubscription ? isSubscriptionElement : !isSubscriptionElement;
        const displayValue = displayValues[key] || 'block';
        
        element.style.display = shouldShow ? displayValue : 'none';
      });
    }

    // Helper method to toggle a list of elements
    toggleElementsList(elements, shouldShow, displayValue = 'block') {
      elements.forEach(element => {
        element.style.display = shouldShow ? displayValue : 'none';
      });
    }

    handleATCClick(e) {
      if (!this.activeProduct || !this.productForm) return;

      e.preventDefault();
      
      // Get the variant ID from the active product
      const variantId = this.activeProduct.dataset.variantId;
      
      // Update the form with the variant ID
      const variantInput = this.productForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }

      // Handle selling plan based on current purchase type
      if (this.currentPurchaseType === 'subscription') {
        // Remove any existing selling plan input
        const existingSellingPlan = this.productForm.querySelector('input[name="selling_plan"]');
        if (existingSellingPlan) {
          existingSellingPlan.remove();
        }

        // Add the selling plan input
        const sellingPlanId = this.activeProduct.dataset.sellingPlanId;
        if (sellingPlanId) {
          const sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          sellingPlanInput.value = sellingPlanId;
          this.productForm.appendChild(sellingPlanInput);
        }
      } else {
        // Remove any existing selling plan input for one-time purchase
        const existingSellingPlan = this.productForm.querySelector('input[name="selling_plan"]');
        if (existingSellingPlan) {
          existingSellingPlan.remove();
        }
      }

      // Submit via AJAX to prevent redirect to /cart and open cart drawer instead
      const formData = new FormData(this.productForm);
      
      // Disable button during submission
      if (this.atcButton) {
        this.atcButton.setAttribute('aria-disabled', true);
        this.atcButton.classList.add('loading');
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Re-enable button
        if (this.atcButton) {
          this.atcButton.removeAttribute('aria-disabled');
          this.atcButton.classList.remove('loading');
        }
        
        // Dispatch cart:item-added event to trigger cart drawer
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: data });
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', { 
            bubbles: true, 
            detail: { product: data } 
          }));
        }
      })
      .catch(error => {
        console.error('[LP Product Selector] Add to cart failed:', error);
        
        // Re-enable button
        if (this.atcButton) {
          this.atcButton.removeAttribute('aria-disabled');
          this.atcButton.classList.remove('loading');
        }
      });
    }

  }

  customElements.define("td-lp-product-selector", TdProductSelector);
}
